import React from 'react';
import BoardApprovalUpdate from '../../features/BoardApprovalUpdate/BoardApprovalUpdate';

const BoardApprovalUpdatePage = () => {
  return (
    <div className="board-approval-update-page">
      <BoardApprovalUpdate />
    </div>
  );
};

export default BoardApprovalUpdatePage;
